<div class="fbo-mobile">
  <header>
    <div class="wrap bar">
      <a href="https://gorillaworks.io/"><img class="logo" src="/assets/homepage/logo-home-header.svg" alt="GorillaWorks" /></a>
      <nav>
        <a class="navlink" href="/home">Platform</a>
        <a class="nav-cta" href="#get">Get the app</a>
      </nav>
    </div>
  </header>

  <section class="hero" id="get">
    <span class="watermark">FlexBackOffice</span>
    <div class="wrap hero-grid">
      <div>
        <span class="eyebrow">FlexBackOffice&trade; Mobile</span>
        <h1>Take your back office anywhere.</h1>
        <p class="lede">Approve timesheets, track placements, and stay on top of payroll and compliance from your phone. The same FlexBackOffice&trade; your team runs, built for mobile.</p>

        <div class="badges">
          <a class="badge-btn" [href]="androidApkUrl">
            <svg width="26" height="26" viewBox="0 0 48 48" aria-hidden="true">
              <line x1="16" y1="6" x2="19.5" y2="12" stroke="#3DDC84" stroke-width="2.4" stroke-linecap="round" />
              <line x1="32" y1="6" x2="28.5" y2="12" stroke="#3DDC84" stroke-width="2.4" stroke-linecap="round" />
              <path d="M11 18 a13 13 0 0 1 26 0 Z" fill="#3DDC84" />
              <circle cx="19" cy="13.4" r="1.7" fill="#12161C" />
              <circle cx="29" cy="13.4" r="1.7" fill="#12161C" />
            </svg>
            <span class="bt"><small>Download for</small><strong>Android</strong></span>
          </a>
          <span class="badge-btn soon" aria-disabled="true">
            <span class="tag">Coming soon</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
              <path d="M17.05 12.04c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.09-2.01-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.89-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.88 2.65 3.22 2.6 1.29-.05 1.78-.83 3.34-.83 1.55 0 2 .83 3.37.81 1.39-.03 2.27-1.27 3.12-2.53.98-1.45 1.39-2.85 1.41-2.92-.03-.01-2.7-1.04-2.73-4.13zM14.6 4.6c.71-.86 1.19-2.06 1.06-3.25-1.02.04-2.26.68-2.99 1.54-.66.76-1.23 1.98-1.08 3.15 1.14.09 2.3-.58 3.01-1.44z" />
            </svg>
            <span class="bt"><small>Download on the</small><strong>App Store</strong></span>
          </span>
        </div>
        <p class="note">Android install (.apk). You may need to allow installs from your browser or file manager. iOS coming soon.</p>
      </div>

      <div class="phone-col">
        <div class="device"><div class="screen"><img class="shot" src="/assets/mobile-app/screen-dashboard.png" alt="FlexBackOffice mobile app dashboard" /></div></div>
      </div>
    </div>
  </section>

  <section class="features">
    <div class="wrap">
      <p class="kicker">Staffing can be tough, but back office should be easy.<br /><b>FlexBackOffice</b> now goes wherever you do.</p>
      <h2>Ready on the go?</h2>
      <div class="fgrid">
        <div class="feature yellow">
          <div class="ic">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#B4791F" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
          </div>
          <h3>Approve on the go</h3>
          <p>Review and approve timesheets and expenses in a tap, so billing never waits on you.</p>
        </div>
        <div class="feature green">
          <div class="ic">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5E7D2A" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
          </div>
          <h3>Placements at a glance</h3>
          <p>See active assignments, start dates, and candidate status without opening your laptop.</p>
        </div>
        <div class="feature mint">
          <div class="ic">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D4F" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.6-3.1 7.6-7 9-3.9-1.4-7-4.4-7-9V6z" /><path d="M9 12l2 2 4-4" /></svg>
          </div>
          <h3>Compliance in your pocket</h3>
          <p>Track documents and credentials so contractors stay work-ready and audit-ready.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="look">
    <div class="wrap">
      <h2>A closer look</h2>
      <p class="sub">Sign in securely, jump straight to work, with more coming to mobile.</p>
      <div class="look-grid">
        <div class="look-item">
          <div class="device"><div class="screen"><img class="shot" src="/assets/mobile-app/screen-login.png" alt="FlexBackOffice secure sign-in" /></div></div>
          <div class="cap">Secure sign-in</div>
        </div>
        <div class="look-item">
          <div class="device"><div class="screen"><img class="shot" src="/assets/mobile-app/screen-menu.png" alt="FlexBackOffice navigation menu" /></div></div>
          <div class="cap">Everything in one menu</div>
        </div>
        <div class="look-item">
          <div class="device"><div class="screen"><img class="shot" src="/assets/mobile-app/screen-workorder.png" alt="FlexBackOffice Work Order coming soon" /></div></div>
          <div class="cap">Built for what's next</div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta">
    <div class="wrap cta-grid">
      <div class="cta-left">
        <h2>Get the FlexBackOffice&trade; app</h2>
        <p>Everything your back office needs, now in your pocket. Install on Android today, with iOS on the way.</p>
      </div>
      <div class="cta-card">
        <img src="/assets/homepage/flexback.svg" alt="FlexBackOffice" />
        <p>Available now for Android. Tap to install.</p>
        <div class="badges">
          <a class="badge-btn" [href]="androidApkUrl">
            <svg width="26" height="26" viewBox="0 0 48 48" aria-hidden="true">
              <line x1="16" y1="6" x2="19.5" y2="12" stroke="#3DDC84" stroke-width="2.4" stroke-linecap="round" />
              <line x1="32" y1="6" x2="28.5" y2="12" stroke="#3DDC84" stroke-width="2.4" stroke-linecap="round" />
              <path d="M11 18 a13 13 0 0 1 26 0 Z" fill="#3DDC84" />
              <circle cx="19" cy="13.4" r="1.7" fill="#12161C" />
              <circle cx="29" cy="13.4" r="1.7" fill="#12161C" />
            </svg>
            <span class="bt"><small>Download for</small><strong>Android</strong></span>
          </a>
          <span class="badge-btn soon" aria-disabled="true">
            <span class="tag">Coming soon</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
              <path d="M17.05 12.04c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.09-2.01-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.89-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.88 2.65 3.22 2.6 1.29-.05 1.78-.83 3.34-.83 1.55 0 2 .83 3.37.81 1.39-.03 2.27-1.27 3.12-2.53.98-1.45 1.39-2.85 1.41-2.92-.03-.01-2.7-1.04-2.73-4.13zM14.6 4.6c.71-.86 1.19-2.06 1.06-3.25-1.02.04-2.26.68-2.99 1.54-.66.76-1.23 1.98-1.08 3.15 1.14.09 2.3-.58 3.01-1.44z" />
            </svg>
            <span class="bt"><small>Download on the</small><strong>App Store</strong></span>
          </span>
        </div>
      </div>
    </div>
  </section>

  <footer>
    <img class="flogo" src="/assets/homepage/footer-logo.svg" alt="GorillaWorks" />
    <div class="divider"></div>
    <div class="site">gorillaworks.io</div>
    <div class="rights">{{ currentYear }} &copy; GorillaWorks Inc. FlexBackOffice&trade; is a trademark of GorillaWorks. All rights reserved.</div>
  </footer>
</div>
